<div
  class="culture-card_container"
  (click)="onCultureCardClick()"
  [ngClass]="{
    'is-mobile-view': isMobileView,
    'is-high-impact': isHighImpact,}"
>
  <app-impact-details
    [familyName]="familyName"
    [iconName]="cultuerIcon"
    [impact]="impact"
    [isLoading]="isLoading"
  ></app-impact-details>
  <mat-divider></mat-divider>
  <app-culture-score-details
    [cultureScore]="cultureScore"
    [progressBarColorString]="progressBarColorString"
    [isLoading]="isLoading"
  ></app-culture-score-details>
</div>
